import DragAndDropGradientList from "./DragAndDropGradientList";
import { useDataStoreMiro } from "../../../refractCommon/utils/useDataStoreMiro";
import "./Colors_Tool.css";
import { gradientsPopular } from "./GradientsPopular";
import Expander from "../../../refractCommon/components/Expander";
import ToolTip from "../../../refractCommon/components/ToolTip";
import { useState } from "react";

const miro = window.miro;

function Gradients({ boardSelection, userIsPro, environment }) {
  const dataKey = "gradientsTool";
  const dataPath = "_gradients";
  const [settingsBoardMine, dispatchSettingsBoardMine] = useDataStoreMiro(
    { [dataPath]: { _order: [] } },
    dataKey,
    true
  );
  const [settingsBoardShared, dispatchSettingsBoardShared] = useDataStoreMiro(
    { [dataPath]: { _order: [] } },
    dataKey,
    false
  );

  const [proShineMyCloud, setProShineMyCloud] = useState(false);
  const [proShineSharedCloud, setProShineSharedCloud] = useState(false);

  // const [sharedGradientBoardSettings, dispatchGradientBoardSettings] = useDataStoreMiro({ _gradients: { _order: [] } }, dataKey)
  // const [sharedGradientCloudSettings, dispatchGradientBoardSettings] = useDataStoreMiro({ _gradients: { _order: [] } }, dataKey)

  return (
    <div id="saved-gradients" className="cs1 ce12 grid">
      <h3 className="h3 cs1 ce12 mt-0 mb-0">
        <b>My Gradients</b>
      </h3>

      <Expander
        title={
          <>
            <div className="cs2 ce11 p-large mt-0">On this Board</div>{" "}
            <div className="cs12 ce12 p-large mt-0 softer-help">
              ({settingsBoardMine[dataPath].length})
            </div>
          </>
        }
        defaultOpen={false}>
        <DragAndDropGradientList
          items={settingsBoardMine[dataPath] || []}
          dataPath={dataPath}
          dispatch={dispatchSettingsBoardMine}
          boardSelection={boardSelection}
          userIsPro={userIsPro}
          environment={environment}
        />
      </Expander>
      <ToolTip
        className="mt--16"
        placement={"top"}
        toolTipContent={
          <>
            Gradients you can access from all of your boards.<br></br>(PRO:
            coming soon)
          </>
        }>
        <div
          className="div cs1 ce12"
          onMouseEnter={() => {
            if (!userIsPro) {
              setProShineMyCloud(true);
            }
          }}
          onMouseLeave={() => {
            if (!userIsPro) {
              setProShineMyCloud(false);
            }
          }}>
          <div className="cs1 ce12 grid cursor-default  ">
            <div className={"cs1 icon m2 mt-0"}>
              <svg
                width="7"
                height="10"
                viewBox="0 0 7 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L6.41421 5L1.70711 9.70711C1.31658 10.0976 0.683417 10.0976 0.292893 9.70711C-0.0976311 9.31658 -0.0976311 8.68342 0.292893 8.29289L3.58579 5L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z"
                  fill="var(--indigo400)"
                />
              </svg>
            </div>

            <div
              className="cs2 ce5 p-large mt-0 "
              style={{ color: "var(--indigo400)" }}>
              All Boards
            </div>
            <p
              onClick={async () => {
                const stripeUrl =
                  "https://www.visualthinking.tools/powerpack-feedback/#comp-l3alhyjs";
                window.open(stripeUrl, "_blank");
              }}
              className={
                "ce12 p-small mb-0 mt-0 inline-pro-plan-upgrade-tag" +
                " " +
                (proShineMyCloud ? "pro-shine" : "")
              }>
              Pro
            </p>
          </div>
        </div>
      </ToolTip>
      <hr className=" cs1 ce12 mb-8 mt-32"></hr>
      <h3 className="h3 cs1 ce12 mt-0 mb-0">
        <b>Shared Gradients</b>
      </h3>

      <Expander
        title={
          <>
            <div className="cs2 ce11 p-large mt-0">On this Board</div>
            <div className="cs12 ce12 p-large mt-0 softer-help">
              ({settingsBoardShared[dataPath].length})
            </div>
          </>
        }>
        <DragAndDropGradientList
          items={settingsBoardShared[dataPath] || []}
          dataPath={dataPath}
          dispatch={dispatchSettingsBoardShared}
          boardSelection={boardSelection}
          userIsPro={userIsPro}
          environment={environment}
        />
      </Expander>
      <ToolTip
        className="mt--16"
        placement={"top"}
        toolTipContent={
          <>
            Gradients your team can access from all team boards.<br></br>(PRO:
            coming soon)
          </>
        }>
        <div
          className="div cs1 ce12"
          onMouseEnter={() => {
            if (!userIsPro) {
              setProShineSharedCloud(true);
            }
          }}
          onMouseLeave={() => {
            if (!userIsPro) {
              setProShineSharedCloud(false);
            }
          }}>
          <div className="cs1 ce12 grid cursor-default ">
            <div className={"cs1 icon m2 mt-0"}>
              <svg
                width="7"
                height="10"
                viewBox="0 0 7 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L6.41421 5L1.70711 9.70711C1.31658 10.0976 0.683417 10.0976 0.292893 9.70711C-0.0976311 9.31658 -0.0976311 8.68342 0.292893 8.29289L3.58579 5L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z"
                  fill="var(--indigo400)"
                />
              </svg>
            </div>

            <div
              className="cs2 ce5 p-large mt-0 "
              style={{ color: "var(--indigo400)" }}>
              All Boards
            </div>
            <p
              onClick={async () => {
                const stripeUrl =
                  "https://www.visualthinking.tools/powerpack-feedback/#comp-l3alhyjs";
                window.open(stripeUrl, "_blank");
              }}
              className={
                "ce12 p-small mb-0 mt-0 inline-pro-plan-upgrade-tag" +
                " " +
                (proShineSharedCloud ? "pro-shine" : "")
              }>
              Pro
            </p>
          </div>
        </div>
      </ToolTip>
      <hr className=" cs1 ce12 mb-8 mt-32"></hr>
      <h3 className="h3 cs1 ce12 mt-0 mb-0">
        <b>Popular Gradients</b>
      </h3>
      <Expander
        title={
          <>
            <div className="cs2 ce11 p-large mt-0 ">You May Enjoy</div>
            <div className="cs12 ce12 p-large mt-0 softer-help">
              ({gradientsPopular.length})
            </div>
          </>
        }
        defaultOpen={false}>
        <div className="cs1 ce12 mt-8"></div>
        <DragAndDropGradientList
          items={gradientsPopular}
          boardSelection={boardSelection}
          userIsPro={userIsPro}
          environment={environment}
        />
      </Expander>
    </div>
  );
}

export default Gradients;
